<template>
  <el-dialog title="执行记录" width="1070px" :visible="isShow" :close-on-click-modal="false" @close="closeDialog">
    <el-form inline ref="searchInfo" :model="searchInfo">
      <el-form-item prop="date">
        <el-date-picker
          v-model="date"
          type="daterange"
          value-format="yyyy-MM-dd"
          start-placeholder="任务开始日期"
          end-placeholder="任务结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="taskStatus">
        <el-select v-model="searchInfo.taskStatus" placeholder="请选择完成情况" filterable clearable>
          <el-option v-for="(item, index) in taskStatusList" :label="item" :value="filtIndex(index)" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="loadList">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
      class="global-table"
      v-loading="loading"
      :data="list"
      border
      :max-height="600"
      highlight-current-row
      @current-change="handleCurrentChange"
    >
      <el-table-column label="任务日期" min-width="220" prop="taskStartTime">
        <template v-slot="{ row }">
          {{row.taskStartTime}} 至 {{row.taskEndTime}}
        </template>
      </el-table-column>
      <el-table-column label="执行人" show-overflow-tooltip prop="executeUserName" min-width="100"></el-table-column>
      <el-table-column label="状态" show-overflow-tooltip prop="taskStatus" min-width="100">
        <template v-slot="{ row }">
          <span
            v-if="[1, 2, 4, 5, 6].includes(row.taskStatus)"
            :class="{ 'c-dark': [1, 2].includes(row.taskStatus),
          'c-yellow': row.taskStatus === 3,
          'c-green': row.taskStatus === 4,
          'c-red': row.taskStatus === 5,
          'c-gray': row.taskStatus === 6 }">
          {{ filtVal(row.taskStatus) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="问题数量" show-overflow-tooltip min-width="100">
        <template v-slot="{row}">共 {{ row.issueNum + ' / 已处理 ' + row.yclIssueNum}}</template>
      </el-table-column>
    </el-table>
    <global-pagination
      @size-change="loadList"
      @current-change="loadList"
      :current-page.sync="page"
      :page-size.sync="size"
      :total="total">
    </global-pagination>
  </el-dialog>
</template>

<script>
export default {
  name: 'recordList',
  props: {
    planId: {
      type: String,
      default: ''
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
  },
  watch: {
    isShow (val) {
      if (val) {
        this.loadList()
      }
    }
  },
  data () {
    return {
      taskStatusList: ['待执行', '执行中', '已完成', '已逾期'],
      date: [],
      searchInfo: {
        startTime: '',
        endTime: '',
        taskStatus: ''
      },
      page: 1,
      size: 10,
      total: 0,
      loading: false,
      list: []
    }
  },
  created () {
  },
  methods: {
    filtIndex (index) {
      let option = 0
      switch (index) {
        case 2:
          option = 4
          break
        case 3:
          option = 5
          break
        default:
          option = index + 1
          break
      }
      return option
    },
    filtVal (status) {
      let option = ''
      switch (status) {
        case 4:
          option = this.taskStatusList[2]
          break
        case 5:
          option = this.taskStatusList[3]
          break
        default:
          option = this.taskStatusList[status - 1]
          break
      }
      return option
    },
    initData () {
      this.date = []
      this.searchInfo = {
        startTime: '',
        endTime: '',
        taskStatus: ''
      }
      this.page = 1
    },
    loadList () {
      this.loading = true
      if (this.date && this.date.length) {
        this.searchInfo.startTime = this.date[0]
        this.searchInfo.endTime = this.date[1]
      } else {
        this.searchInfo.startTime = ''
        this.searchInfo.endTime = ''
      }
      this.$axios.get(this.$apis.patrol.selectTaskByPage, {
        ...this.searchInfo,
        planId: this.planId,
        page: this.page,
        size: this.size
      }).then(res => {
        this.list = res.list || []
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    handleCurrentChange (val) {
      console.log('handleCurrentChange', val)
      if (val) {
        this.$event.$emit('task-info-init', val.taskId)
        this.closeDialog()
      }
    },
    // 关闭
    closeDialog () {
      this.initData()
      this.$emit('update:isShow', false)
    }
  }
}
</script>

<style scoped lang="scss">
</style>
